import React from "react";

function InOut() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="14"
      fill="none"
      viewBox="0 0 13 14"
    >
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M.5 5h12l-4-4M12.5 9H.5l4 4"
      ></path>
    </svg>
  );
}

export default InOut;
